import api from "./Api";

class RecaptchaService {
  PostRecaptchaValidate(payload) {
    return api.post("/v1/Recaptcha/validate/", payload).then((response) => {
      return response.data;
    });
  }
}

export default new RecaptchaService();
